export default 'https://tme.understood.org/assets/trousse.ea35e01b.glb'